import { render, staticRenderFns } from "./style.md?vue&type=template&id=df324a7c&"
import script from "./style.md?vue&type=script&lang=js&"
export * from "./style.md?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/core/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('df324a7c')) {
      api.createRecord('df324a7c', component.options)
    } else {
      api.reload('df324a7c', component.options)
    }
    module.hot.accept("./style.md?vue&type=template&id=df324a7c&", function () {
      api.rerender('df324a7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "website/views/more/test/style.md"
export default component.exports